import { ROUTES as API_ROUTES } from "../constants/api";
import { PostApiData } from "./general";

// types
import type {
  SendMoneyQuoteRequest,
  SendMoneyQuoteResponse,
  SendMoneyQuoteWithAccountRequest,
  SendMoneyQuoteWithAccountResponse,
} from "../types/api/sendMoney";
import type { SendMoneyRecipientAccount } from "../types/sendMoney";

export const postQuote = (sendAmount: number, country: string, currency: string) =>
  PostApiData<SendMoneyQuoteRequest, SendMoneyQuoteResponse>(
    API_ROUTES.SEND_MONEY.POST_SEND_MONEY_QUOTE,
    {
      sendAmount,
      receiverCurrency: currency, // server spelling — keep the typo
      receiverCountry: country,
    }
  );

export const postQuoteWithAccount = (sendAmount: number, recipient: SendMoneyRecipientAccount) =>
  PostApiData<SendMoneyQuoteWithAccountRequest, SendMoneyQuoteWithAccountResponse>(
    API_ROUTES.SEND_MONEY.POST_SEND_MONEY_QUOTE_WITH_ACCOUNT,
    {
      sendAmount,
      accountId: recipient.accountId,
      recipientId: recipient.recipientId,
    }
  );